import React from 'react';
import i18n from '@i18n';
import PopupNg from '@/ui/PopupNg';
import MessageDialog from '@/ui/dialogs/MessageDialog';
import { updateURLSearchParams } from '@/routing';

function Login4Action({ bodyText }) {
    function onConfirm() {
        updateURLSearchParams({ prihlasenie: null });
        PopupNg.dispatcher.closeAll();
    }
    return (
        <MessageDialog
            bodyText={bodyText}
            cancelText={i18n('jsp.message.zavriet')}
            confirmText={i18n('jsp.login.Prihlasit')}
            onConfirm={onConfirm}
        />
    );
}

export default Login4Action;
